import { get, post } from '../utils/api';

export const getDashboardTree = (childId, yearGroup) => {
  const query = yearGroup ? `?yearGroup=${encodeURIComponent(yearGroup)}` : '';
  return get(`/dashboard/${childId}${query}`, true);
};

export const getLessonAttempts = (childId, lessonId) =>
  get(`/dashboard/${childId}/lesson/${lessonId}/attempts`, true);

export const startCoreSkillSession = (childId, lessonId, source = 'dashboard_progress') =>
  post(`/dashboard/${childId}/core-skill-session/start`, { lessonId, source }, true);

export const completeCoreSkillSession = (childId, sessionId) =>
  post(`/dashboard/${childId}/core-skill-session/${sessionId}/complete`, {}, true);

export const getActiveCoreSkillSession = (childId, options = {}) => {
  const params = new URLSearchParams();
  if (options.lessonId) params.set('lessonId', options.lessonId);
  if (options.source) params.set('source', options.source);
  const query = params.toString() ? `?${params.toString()}` : '';
  return get(`/dashboard/${childId}/core-skill-session/active${query}`, true);
};

export const getRedQueue = (childId) => get(`/dashboard/${childId}/red-queue`, true);

export const completeForced = (childId, lessonId) =>
  post(`/dashboard/${childId}/red-queue/complete-forced`, { lessonId }, true);

export const finalizeForced = (childId, submissionId) =>
  post(`/dashboard/${childId}/red-queue/finalize-forced`, { submissionId }, true);

